module.exports = __webpack_public_path__ + "img/greensock.png.6440573b.webp";